import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../../contexts/auth';
import Loading from '../../components/custom-loading';
import { toast } from 'react-toastify';

/**
 * Página para autenticação via token na URL
 * Uso: /auth/token?token=SEU_TOKEN_JWT&redirect=/caminho (opcional)
 *
 * Exemplos:
 * - /auth/token?token=eyJhbGc...
 * - /auth/token?token=eyJhbGc...&redirect=/account
 * - /auth/token?token=eyJhbGc...&redirect=/checkout/premium/details
 */
const TokenAuth: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setTokenFromUrl, loadingAuth } = useContext(AuthContext);
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    const processTokenAuth = async () => {
      try {
        // Captura o token e o caminho de redirecionamento da URL
        const token = searchParams.get('token');
        const redirectPath = searchParams.get('redirect') || '/';

        // Valida se o token foi fornecido
        if (!token) {
          toast.error('Token não fornecido na URL', {
            position: 'top-center',
            theme: 'colored',
          });
          navigate('/', { replace: true });
          return;
        }

        // Processa o token usando o contexto de autenticação
        const success = await setTokenFromUrl(token);

        if (success) {
          toast.success('Autenticação realizada com sucesso!', {
            position: 'top-center',
            theme: 'colored',
            autoClose: 2000,
          });

          // Redireciona para o caminho especificado ou home
          setTimeout(() => {
            navigate(redirectPath, { replace: true });
          }, 1000);
        } else {
          toast.error('Token inválido ou expirado', {
            position: 'top-center',
            theme: 'colored',
          });
          navigate('/', { replace: true });
        }
      } catch (error) {
        console.error('Erro ao processar autenticação via token:', error);
        toast.error('Erro ao processar autenticação. Tente novamente.', {
          position: 'top-center',
          theme: 'colored',
        });
        navigate('/', { replace: true });
      } finally {
        setProcessing(false);
      }
    };

    processTokenAuth();
  }, [searchParams, navigate, setTokenFromUrl]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Loading visibled={processing || loadingAuth} />
      <div style={{ textAlign: 'center', marginTop: 20 }}>
        <h3 style={{ color: '#4b90cf', marginBottom: 10 }}>
          Processando autenticação...
        </h3>
        <p style={{ color: '#666' }}>Por favor, aguarde.</p>
      </div>
    </div>
  );
};

export default TokenAuth;
